export const LOAD_SATHIERARCHYDATA = "LOAD_SATHIERARCHYDATA";
export const LOAD_SATHIERARCHYDATA_SUCCESS = "LOAD_SATHIERARCHYDATA_SUCCESS";
export const LOAD_SATHIERARCHYDATA_ERROR = "LOAD_SATHIERARCHYDATA_ERROR";


